import Splide from '@splidejs/splide'

// only core styles
import '@splidejs/splide/css/core'

declare global {
    interface Window {
        Splide: any
    }
}

window.Splide = Splide
